import { _ as __rest, a as __assign } from './tslib.es6-1ab78651.js';
import { c as classNames } from './index-8c9393ca.js';
import * as React from 'react';
import { s as skeletonStyles } from './skeleton.module-da702321.js';

var styles = {"container":"IconButton_container_add6fc68","focus-visible":"IconButton_focus-visible_add6fc68","disabled":"IconButton_disabled_add6fc68","skeleton":"IconButton_skeleton_add6fc68","border":"IconButton_border_add6fc68"};

var IconButton = React.forwardRef(function IconButton(props, ref) {
    var _a;
    var onClick = props.onClick, className = props.className, children = props.children, hasBorder = props.hasBorder, isSkeleton = props.isSkeleton, disabled = props.disabled, label = props.label, otherProps = __rest(props, ["onClick", "className", "children", "hasBorder", "isSkeleton", "disabled", "label"]);
    var isDisabled = disabled || isSkeleton;
    return (React.createElement("button", __assign({ ref: ref, onClick: onClick, disabled: isDisabled, className: classNames(styles.container, className, (_a = {},
            _a[styles.border] = hasBorder,
            _a[skeletonStyles.skeleton] = isSkeleton,
            _a[styles.skeleton] = isSkeleton,
            _a[styles.disabled] = disabled,
            _a)), "aria-busy": isSkeleton, "aria-label": label, "data-testid": "icon-button" }, otherProps), children));
});

export { IconButton as I };
